import { cva } from 'class-variance-authority'

export const primaryHeaderStyles = cva(
  `
    text-green-600
    bg-green-100/10
    font-bold
    h-[38px]
    [&>td:first-child]:rounded-l-lg
    [&>td:last-child]:rounded-r-lg
  `
)

export const secondaryHeaderStyles = cva(
  `
    text-green-600
    outline
    outline-2
    outline-dashed
    outline-[#e0e0e0]
    rounded-lg
    border-t-[5px]
    border-t-white
    outline-offset-3
  `
)
